import "./Home.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import TheLegendsArrival from "./sections/TheLegendsArrival";
import CoreCommodities from "./sections/CoreCommodities";
import CompanyOverview from "./sections/CompanyOverview";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <FraternalExcellenceHeader />
      <TheLegendsArrival />
      <CompanyOverview />
      <CoreCommodities />
      <Footer />
    </div>;
}